<template>
  <div id="app" class="aaa">
  <!-- <float-button></float-button> -->
    <router-view />
    <!-- <vueDarg></vueDarg> -->
    <!-- <floatButtoncopy></floatButtoncopy> -->
  </div>
</template>

<script>
import AppTabbar from '@/components/AppTabbar'

export default {
  data() {
    return {
      username:'',
      password:'',
      isShowModal: true,
    }
  },
  methods:{
    onSubmit(values){
      
    }
  },
  components: {
    AppTabbar,
    floatButton: () => import("@/components/floatButton"),
    // floatButtoncopy: () => import("@/components/floatButtonCopy"),

    vueDarg: () => import("@/components/vueDrag"),
  },
  mounted(){
    //  window.addEventListener('resize', () => {
    //     console.log('1234567890')
    //       var aaa = document.getElementsByClassName('aaa')[0];
    //     if (window.innerHeight < window.innerWidth) {
    //       console.log('横屏的时候++++++++aaaa')
    //       aaa.style.transform = 'rotate(-90deg)';
    //       // document.documentElement.style.transform = 'rotate(-90deg)';
    //       aaa.style.width = '100vh';
    //       aaa.style.height = '100vw';
    //       aaa.style.border = '5px solid red';

    //     } else {
    //       console.log('竖屏的时候===================aaaa')
    //       aaa.style.transform = 'rotate(0deg)';
    //       aaa.style.height = '100vh';
    //       // aaa.style.width = '100vw';
    //       aaa.style.border = '10px solid blue';

    //       // bg_tab.style.border = '5px solid yellow';
    //     }
    //   });
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #efefef;
  min-height: 100%;
  font-size: .14rem;
}

html,
body {
  height: 100%;
}

html {
  font-size: 100px !important; // 16px?? 
  // font-size:16px;
}

</style>
